import { render, staticRenderFns } from "./Setting.Service.vue?vue&type=template&id=c9eb243c&"
import script from "./Setting.Service.vue?vue&type=script&lang=js&"
export * from "./Setting.Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports